module.exports = __webpack_public_path__ + "static/media/frame1.7daad2bc.jpg";